import { createContext } from "react";

export const FieldContext = createContext<Record<number, string[]>>({});